var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "VIDEO"
    ? _c("video-card", {
        attrs: {
          "form-model": _vm.formModel,
          "is-hide-options": _vm.isHideOptions,
          "is-hide-add-reference": _vm.isHideAddReference,
          "is-hide-goover": _vm.isHideGoover,
          "is-hide-hidden": _vm.isHideHidden,
          "is-hide-shared": _vm.isHideShared,
        },
        on: {
          hide: function ($event) {
            $event.stopPropagation()
            return _vm.hide.apply(null, arguments)
          },
          share: _vm.share,
          "view-detail": _vm.viewDetail,
          "toggle-resource": _vm.toggleResource,
          "select-user-social": _vm.selectUserSocial,
          "add-to-reference": _vm.addToReference,
          goover: _vm.goover,
        },
      })
    : _vm.type === "SOCIAL"
    ? _c("social-card", {
        attrs: {
          "form-model": _vm.formModel,
          "is-hide-options": _vm.isHideOptions,
          "is-hide-add-reference": _vm.isHideAddReference,
          "is-hide-goover": _vm.isHideGoover,
          "is-hide-hidden": _vm.isHideHidden,
          "is-hide-shared": _vm.isHideShared,
        },
        on: {
          hide: function ($event) {
            $event.stopPropagation()
            return _vm.hide.apply(null, arguments)
          },
          share: _vm.share,
          "view-detail": _vm.viewDetail,
          "toggle-resource": _vm.toggleResource,
          "select-user-social": _vm.selectUserSocial,
          "add-to-reference": _vm.addToReference,
          goover: _vm.goover,
        },
      })
    : _vm.type === "FILE"
    ? _c("file-card", {
        attrs: {
          "form-model": _vm.formModel,
          "is-hide-options": _vm.isHideOptions,
          "is-hide-add-reference": _vm.isHideAddReference,
          "is-hide-goover": _vm.isHideGoover,
          "is-hide-hidden": _vm.isHideHidden,
          "is-hide-shared": _vm.isHideShared,
        },
        on: {
          hide: function ($event) {
            $event.stopPropagation()
            return _vm.hide.apply(null, arguments)
          },
          share: _vm.share,
          "view-detail": _vm.viewDetail,
          "toggle-resource": _vm.toggleResource,
          "select-user-social": _vm.selectUserSocial,
          "add-to-reference": _vm.addToReference,
          goover: _vm.goover,
        },
      })
    : _c("article-card", {
        attrs: {
          "form-model": _vm.formModel,
          "is-hide-options": _vm.isHideOptions,
          "is-hide-add-reference": _vm.isHideAddReference,
          "is-hide-goover": _vm.isHideGoover,
          "is-hide-hidden": _vm.isHideHidden,
          "is-hide-shared": _vm.isHideShared,
        },
        on: {
          hide: function ($event) {
            $event.stopPropagation()
            return _vm.hide.apply(null, arguments)
          },
          share: _vm.share,
          "view-detail": _vm.viewDetail,
          "toggle-resource": _vm.toggleResource,
          "select-user-social": _vm.selectUserSocial,
          "add-to-reference": _vm.addToReference,
          goover: _vm.goover,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }